export default {
      id: "oc-icon_notice-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_notice",
      toString: function () {
        return this.url;
      }
    }